import React, { useState } from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from './Login.styles';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import Layout from '../Layout';
import { FcGoogle } from 'react-icons/fc';
import { Link, useNavigate } from 'react-router-dom';
import iconUser from '../../assets/icon-user.svg';
import iconEmail from '../../assets/icon-email.svg';
import iconKey from '../../assets/icon-key.svg';
import authService from '../../services/authService';
import Toast from '../Toast';
import { useGoogleLogin } from '@react-oauth/google';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import { convertToFormData } from '../../helpers/common';

function Signup() {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // const { onGoogleLogin, loading_user_google } = useContextHook(AuthContext, v => ({
  //   onLogin: v.onLogin,
  //   loading_user: v.loading_user,
  //   onGoogleLogin: v.onGoogleLogin,
  //   loading_user_google: v.loading_user_google,
  // }));

  // const googleLogin = useGoogleLogin({
  //   onSuccess: async tokenResponse => {
  //     const { access_token } = tokenResponse;
  //     console.log(tokenResponse);
  //     onGoogleLogin({ access_token, action: 'Register' });
  //   },
  // });
  const toFormData = obj => {
    const formData = new FormData();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        formData.append(key, obj[key]);
      }
    }
    return formData;
  };
  const handleSubmit = async e => {
    setLoading(true);
    const payload = {
      first_name: e?.first_name,
      last_name: e?.last_name,
      email: e?.email,
      password: e?.password,
    };
    try {
      const resp = await authService.register(payload);
      localStorage.setItem('email', e?.email);
      setLoading(false);

      if (resp.success) {
        Toast({ type: 'success', message: resp.detail });
        // await authService.sendOtp({ email: e?.email });
        navigate('/');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // Toast({ type: 'error', message: error.message });
    }
  };

  return (
    <Layout showTemplate={false}>
      <OnboardingTemplate>
        <FormContent>
          <div className="text-content">
            <div className="text-wrapper">
              <div className="heading-text">
                <h1>Create a free account</h1>
                {/* <p>Join Houdiny – Smart AI Outreach!</p> */}
              </div>
              <div className="formWrapper">
                <Form form={form} onSubmit={handleSubmit}>
                  <Form.Item
                    label="First Name"
                    type="text"
                    name="first_name"
                    placeholder="Enter your first name"
                    rules={[
                      {
                        required: true,
                        message: 'first name is Required',
                      },
                    ]}
                    prefix={<img src={iconUser} alt="person" width={24} height={24} />}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    label="Last Name"
                    name="last_name"
                    placeholder="Enter your last name"
                    rules={[
                      {
                        required: true,
                        message: 'last name is Required',
                      },
                    ]}
                    prefix={<img src={iconUser} alt="person" width={24} height={24} />}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    label="Email Address"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    rules={[
                      {
                        required: true,
                        message: 'Email is Required',
                      },
                    ]}
                    prefix={<img src={iconEmail} alt="person" width={24} height={24} />}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    label="Password"
                    type="password"
                    name="password"
                    placeholder="Enter password"
                    prefix={<img src={iconKey} alt="person" width={24} height={24} />}
                    rules={[
                      {
                        required: true,
                        message: 'Password is Required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                  <div className="text-box">
                    <Form.Item
                      noMargin
                      type="checkbox"
                      rounded
                      name="checkbox"
                      label={
                        <>
                          <div className="privacy">
                            <p>
                              By proceeding, you acknowledge and accept our <span className="color">Terms</span> and{' '}
                              <span className="color">Privacy Policy</span> .
                            </p>
                          </div>
                        </>
                      }>
                      <Field />
                    </Form.Item>
                  </div>
                  <div className="btn-holder">
                    <Button loader={loading}>Sign Up Now</Button>
                  </div>
                </Form>
                <div className="seprator">
                  <span className="text">OR</span>
                </div>
                <button className="googleAuth">
                  <div className="img-holder">
                    <FcGoogle />
                  </div>{' '}
                  Continue with Google
                </button>
              </div>
            </div>
            <div className="footer">
              Already have an account? <Link to="/">Sign In</Link>{' '}
            </div>
          </div>
        </FormContent>
      </OnboardingTemplate>
    </Layout>
  );
}

export default Signup;
